import styled from "styled-components";


export const Container = styled.footer`
  background-color: #2b2b2b;
  padding: 3rem 15rem;
  margin-top: 10rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .logo {
    width: 270px;
  }

  .logo img{
    height: 55px;
  }

  p{
    letter-spacing: 0.2rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    img{
      width: 2.6rem;
      animation: spinning 5s infinite linear;
    }
  }

  .version{
    display: block;
    margin-top: 0.4rem;
    font-size: 1.2rem;
    opacity: 0.7;
    text-align: center;
    width: 100%;
  }

  /* Center stacking for the text + version inside the middle column */
  & > .version {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .policy-links{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;

    a {
    color: #fb804b;
    }

    img,span{
      font-size: 3rem;
    }
  }


  @keyframes spinning {
    0%{
      transform: rotate(0);
    }
    100%{
      transform: rotate(360deg);
    }
  }

  @media(max-width: 800px){
    padding: 4rem 10rem;
    flex-direction: column;
    gap: 2rem;
    text-align: center;
  }
  @media(max-width: 600px){
    padding: 4rem 1rem;
    p{
      font-size: 1.2rem;
    }
  }
`